<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showCreateBenefit"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <form
          @submit.prevent="create"
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-2/5 w-full"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">Create Job Grade</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="create_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ create_error }}
            </div>
          </transition>
          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1 capitalize">Job Grade</label>
              <input
                type="text"
                v-model="info.Name"
                class="border-0.5 border-gray-400 p-2 w-full"
                placeholder="Enter Job Grade"
              />
            </div>
            <div class="text-sm">
              <label class="block pb-1 capitalize">Minimum Salary</label>
              <input
                type="number"
                v-model="info.MinSalary"
                class="border-0.5 border-gray-400 p-2 w-full"
                placeholder="Enter Minimum Salary"
              />
            </div>
            <div class="text-sm">
              <label class="block pb-1 capitalize">Maximum Salary</label>
              <input
                type="number"
                v-model="info.MaxSalary"
                class="border-0.5 border-gray-400 p-2 w-full"
                placeholder="Enter Maximum Salary"
              />
            </div>
          </div>
          <div class="flex justify-end p-5">
            <button
              type="submit"
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Create
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";

export default {
  name: "CompanyJobGrades",
  props: ["showCreateBenefit"],
  components: { Loader },
  data() {
    return {
      create_error: null,
      loading: false,
      info: {
        Name: "",
        MinSalary: null,
        MaxSalary: null,
      },
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },
  methods: {
    close() {
      this.$emit("close");
    },
    create() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      axios
        .post(
          `${this.getOrganization}/setup/jobgrade/${this.$ApiVersion}/create`,
          JSON.stringify(this.info),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.$emit("closeOnSuccess");
              this.info = {
                Name: "",
                MinSalary: null,
                MaxSalary: null,
              };
            } else {
              this.create_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
          }
        );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
